import { PriorityTypesTranslations } from "./types";

export const dePriorityTranslations: PriorityTypesTranslations = {
    LOW: "Niedrig",
    MEDIUM: "Mittel",
    HIGH: "Hoch",
};
